import { t } from 'i18next';
import { GridFlex, Text, Field } from '@stigg-components';
import { SelectProps } from '../../../../components/Select';
import * as Yup from 'yup';
import { TooltipFields } from 'src/components/InformationTooltip';

export function getAuthorizedDomainField<FormValues>({
  withLabels = false,
  domains,
  disabled,
  tooltip,
}: {
  withLabels?: boolean;
  domains: string[];
  tooltip?: TooltipFields;
  disabled?: boolean;
}): Field<FormValues> {
  const menuProps: Partial<SelectProps> = {
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    transformOrigin: { horizontal: 'left', vertical: 'top' },
  };
  return {
    type: 'select',
    id: 'authorizedDomain',
    disabled,
    tooltip,
    restProps: {
      ...menuProps,
    },
    label: withLabels ? t('accounts.loginOptions.authorizedDomain.fieldLabel') : undefined,
    values: domains.map((domain) => ({
      value: domain,
      overrideDisplayValue: (
        <GridFlex.RowCenter columnGap={2}>
          <Text.B2 color="primary">{`@ ${domain}`}</Text.B2>
        </GridFlex.RowCenter>
      ),
      displayValue: (
        <GridFlex.RowCenter columnGap={2}>
          <GridFlex.Column>
            <Text.B1 color="primary">{`@ ${domain}`}</Text.B1>
          </GridFlex.Column>
        </GridFlex.RowCenter>
      ),
    })),
  };
}

export function getAuthorizedDomainFieldValidationSchema(forbiddenDomains: string[]) {
  return {
    authorizedDomain: Yup.string().notOneOf(forbiddenDomains).required(t('fieldValidationMessages.required')),
  };
}
